import React from 'react';
import { Link } from 'react-router-dom';

const DashboardTile: React.FC<TileProps> = ({ title, description, icon, path }) => {
    return (
        <Link to={path}>
            <div className="tile">
                {icon && <i className={`icon fal fa-fw fa-${icon}`}></i>}
                <h2>{title}</h2>
                {description && <p>{description}</p>}
            </div>
        </Link>
    );
};

interface TileProps {
    title: string;
    icon?: string;
    description?: string;
    path: string;
}

export default DashboardTile;
